const MobileSearchNearbyCard = ({ nearbyOnly, setNearbyOnly }) => (
  <div className="mb-5 flex items-center justify-between rounded-2xl border border-black/5 bg-white px-4 py-4 shadow-[0_10px_28px_rgba(15,23,42,0.08)] dark:bg-white/10 dark:border-white/10">
    <div className="flex min-w-0 items-center">
      <span className="min-w-0">
        <span className="block text-[16px] font-semibold leading-5">
          내 주변만 보기
        </span>
        <span className="mt-1 block truncate text-[12px] font-medium text-black/45 dark:text-white/45">
          현재 위치 주변의 장소만 표시합니다
        </span>
      </span>
    </div>
    <button
      type="button"
      aria-pressed={nearbyOnly}
      className={`relative h-[30px] w-12 shrink-0 rounded-full transition ${
        nearbyOnly ? "bg-red" : "bg-black/12 dark:bg-white/20"
      }`}
      onClick={() => setNearbyOnly(!nearbyOnly)}
    >
      <span
        className={`absolute top-1 h-[22px] w-[22px] rounded-full bg-white shadow transition ${
          nearbyOnly ? "left-[22px]" : "left-1"
        }`}
      />
    </button>
  </div>
);

export default MobileSearchNearbyCard;
